module.exports = __webpack_public_path__ + "img/gift5-06-c1.f84b5f5b.png";